import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.array.push.js";
import Dialog from "./dialog";
export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "default"
        },
        title: {
            type: String,
            default: "选择商品"
        },
        placeholder: {
            type: String,
            default: "链接"
        }
    },
    components: {
        Dialog
    },
    data () {
        return {
            typeList: {
                1: '商品',
                2: '课程商品'
            },
            visible: false,
            isSaveing: false,
            url: [],
            package: [],
            pageNo: 1,
            pageSize: 10,
            isInternalUpdate: false
        };
    },
    watch: {
        modelValue: {
            handler (newVal) {
                this.package = newVal || [];
                // 同步当前已选到弹窗内部的 v-model，避免因默认值 "" 导致校验失败
                this.url = Array.isArray(newVal) ? [
                    ...newVal
                ] : newVal ? [
                    newVal
                ] : [];
                // 只有非内部更新时才重置分页（避免删除操作时重置分页）
                if (!this.isInternalUpdate) {
                    this.resetPagination();
                }
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        pagedPackage () {
            const start = (this.pageNo - 1) * this.pageSize;
            return this.package.slice(start, start + this.pageSize);
        },
        totalPrice () {
            // const hasPrice = this.package.every(item => item.price !== undefined && item.price !== null);
            //   if (!hasPrice) {
            //       return '--';
            //   }
            //   return this.package.reduce((total, item) => total + item.price * item.num, 0);
            return this.package.reduce((total, item)=>total + item.price * item.num, 0);
        }
    },
    methods: {
        openSelect () {
            this.visible = true;
            this.$nextTick(()=>{
                console.log(this.$refs.Dialog);
                this.$refs.Dialog.open();
            });
        },
        selectType (val) {
            return this.typeList[val];
        },
        handleChange (e) {},
        resetPagination () {
            this.pageNo = 1;
        },
        handlePageChange (page) {
            this.pageNo = page;
        },
        handlePageSizeChange (size) {
            this.pageSize = size;
            this.pageNo = 1;
        },
        //表单提交方法
        submit () {
            if (!this.url || Array.isArray(this.url) && this.url.length === 0) {
                this.$message.error('请选择');
                return;
            }
            this.isSaveing = true;
            // 支持多选数组
            const selectedItems = Array.isArray(this.url) ? this.url : [
                this.url
            ];
            selectedItems.forEach((item)=>{
                // 处理类型转换
                let finalType = item.type;
                if (item.type == 4) {
                    finalType = 1;
                } else if (item.type == 3) {
                    finalType = 2;
                }
                let obj = {
                    title: item.title,
                    type: finalType,
                    id: item.id
                };
                // 检查是否已存在，如果存在则跳过（避免重复添加）
                let found = this.package.find((pkgItem)=>pkgItem.id === item.id && pkgItem.type === finalType);
                if (!found) {
                    this.package.push(obj);
                }
            });
            this.isSaveing = false;
            this.visible = false;
            this.$emit('update:modelValue', this.package);
        },
        deleteData (row, index) {
            // 计算真实索引：当前页的起始索引 + 当前页内的相对索引
            const realIndex = (this.pageNo - 1) * this.pageSize + index;
            this.package.splice(realIndex, 1);
            // 删除后检查当前页是否还有数据，如果没有则跳转到上一页
            const totalPages = Math.ceil(this.package.length / this.pageSize);
            if (this.pageNo > totalPages && totalPages > 0) {
                this.pageNo = totalPages;
            }
            // 标记为内部更新，避免触发 watch 中的分页重置
            this.isInternalUpdate = true;
            // 触发更新事件
            this.$emit('update:modelValue', this.package);
            // 使用 nextTick 确保 watch 执行完毕后再重置标志位
            this.$nextTick(()=>{
                this.isInternalUpdate = false;
            });
        },
        clear () {
            this.isSaveing = true;
            this.$emit('update:modelValue', '');
            this.isSaveing = false;
            this.visible = false;
        }
    }
};
